import React from 'react';
import { motion } from 'framer-motion'; // Import framer-motion
import college from "../../assets/Home/college.jpg";
import SidebarGalleryPage from "../../Components/Main/Sidebargallery"

const Mission = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="flex flex-wrap lg:flex-nowrap p-10 gap-8">
        <div>
          {/* Image with animation */}
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            <img
              src={college}
              alt="CSE"
              className="w-full shadow-md p-2 border-4 border-teal-500 rounded-lg mb-10"
            />
          </motion.div>

          {/* Mission Section */}
          <motion.div
            className="border-4 border-teal-500 rounded-lg p-2"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            {/* Animated Heading */}
            <motion.h2
              className="text-white bg-teal-500 text-xl p-2 font-bold rounded-sm"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.5 }}
            >
              Mission
            </motion.h2>
            
            {/* Animated Text */}
            <motion.div
              className="p-2 text-gray-800"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1, delay: 0.3 }}
            >
              <p className="mb-4">
                Government Women’s Polytechnic College, Sehore will conduct Engineering and office management
                based professional Diploma courses for only SC women/girls students. So this organization attempts
                to provide job-oriented skills for those girls which belong to backward areas. Its target of women 
                empowerment through its long and short-term technical education programs. It shall provide a dynamic, 
                challenging & ethical environment for pursuing high-quality teaching, research, learning & service
                across all areas of states.
              </p>
            </motion.div>
          </motion.div>
        </div>
        {/* Right Section: Gallery */}
        <div className="w-full">
            <SidebarGalleryPage />
        </div>
      </div>
    </div>
  );
};

export default Mission;
